var _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.8,4.9h-4.4V4.7c0-0.8-0.7-1.5-1.5-1.5H10c-0.8,0-1.5,0.7-1.5,1.5v0.2H4.2C3,4.9,2,5.9,2,7.1v10.7 C2,19,3,20,4.2,20h15.6c1.2,0,2.2-1,2.2-2.2V7.1C22,5.9,21,4.9,19.8,4.9z M10.1,4.7H14v1.8h-3.9V4.7z M20.5,17.8 c0,0.4-0.3,0.7-0.7,0.7H4.2c-0.4,0-0.7-0.3-0.7-0.7V7.1c0-0.4,0.3-0.7,0.7-0.7h4.4v0.1C8.6,7.3,9.2,8,10.1,8H14 c0.8,0,1.5-0.7,1.5-1.5V6.4h4.4c0.4,0,0.7,0.3,0.7,0.7v10.7H20.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,10.7H5.8c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h12.3c0.3,0,0.6,0.3,0.6,0.6S18.5,10.7,18.2,10.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,13.9H5.8c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h12.3c0.3,0,0.6,0.3,0.6,0.6 C18.8,13.6,18.5,13.9,18.2,13.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,16.8H5.8c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h12.3c0.3,0,0.6,0.3,0.6,0.6S18.5,16.8,18.2,16.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.0218b85f.svg";
export { ForwardRef as ReactComponent };